import type { GridProps, TextProps } from '@chakra-ui/react'
import { Grid, Text } from '@chakra-ui/react'

import type { RecapTableItemProps } from './RecapTableItem'
import { RecapTableItem } from './RecapTableItem'

export interface RecapTableRowProps extends GridProps {
  title: string
  titleProps?: TextProps
  items?: RecapTableItemProps[]
  itemsGridProps?: GridProps
}

export const RecapTableRow = ({
  title,
  titleProps,
  items,
  sx,
  itemsGridProps,
  ...rest
}: RecapTableRowProps) => {

  return (
    <Grid
      sx={{
        gap: 2,
        pb: 2,
        borderBottom: '1px solid',
        borderBottomColor: 'neutral.50',
        ...sx,
      }}
      {...rest}
    >
      <Text {...titleProps} sx={{ fontSize: 'sm', ...titleProps?.sx }}>
        {title}
      </Text>

      <Grid gap={1.5} {...itemsGridProps}>
        {items?.map(({ label, value, labelProps }, index) => {
          return <RecapTableItem key={index} label={label} value={value} labelProps={labelProps} />
        })}
      </Grid>
    </Grid>
  )
}
